import { Bell, Menu, Shield } from 'lucide-react';
import { useHeaderSlot } from '../../contexts/SuperAdminHeaderContext';
import styles from '../../assets/scss/layout/SuperAdminHeader.module.scss';

export default function SuperAdminHeader({ onMobileToggle, collapsed }) {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const name = user.userName || 'SuperAdmin';
    const { slot } = useHeaderSlot();

    return (
        <header className={`${styles.topbar}${collapsed ? ` ${styles.sidebarCollapsed}` : ''}`}>
            <div className={styles.topbarLeft}>
                <button className={styles.topbarHamburger} onClick={onMobileToggle}>
                    <Menu />
                </button>
                {slot}
            </div>

            <div className={styles.topbarRight}>
                <button className={styles.topbarIconBtn}>
                    <Bell />
                </button>

                <div className={styles.topbarDivider} />

                <div className={styles.topbarUser}>
                    <div className={styles.topbarUserInfo}>
                        <span className={styles.topbarUserName}>{name}</span>
                        <span className={styles.topbarUserRole}>Superadmin</span>
                    </div>
                    <div className={styles.topbarAvatar}>
                        <Shield size={18} />
                    </div>
                </div>
            </div>
        </header>
    );
}
